import React, { useCallback, useContext, useEffect, useState } from 'react';
import i18next from 'i18next';
import NotesList from '../../../notes/NotesList';
import EAAccordion from '../../../../components/EAAccordion';
import {
  createNoteContextInstance,
  deleteNoteContextInstance,
  getAllNoteContextInstance,
  updateNoteContextInstance,
} from '../../../../services/edge/NoteService';
import { Context } from '../../../../states/Store';
import {
  PrivilegeEnum,
  RoleBasedAccessControlContext,
} from '../../../../services/common/RolesUtils';

const Notes = ({ contextInstance }) => {
  const [state, dispatch] = useContext(Context);
  const [notes, setNotes] = useState([]);
  const { hasAnyOfPrivileges } = useContext(RoleBasedAccessControlContext);

  const createNote = async (noteContent) => {
    await createNoteContextInstance(
      state.account.id,
      contextInstance.id,
      noteContent,
      dispatch
    );
  };

  const updateNote = useCallback(
    async (noteOId, noteContent) => {
      await updateNoteContextInstance(
        state.account.id,
        contextInstance.id,
        noteOId,
        noteContent,
        dispatch
      );
    },
    [contextInstance, state.account.id, dispatch]
  );

  const deleteNote = useCallback(
    async (noteOId) => {
      await deleteNoteContextInstance(
        state.account.id,
        contextInstance.id,
        noteOId,
        dispatch
      );
    },
    [contextInstance, state.account.id, dispatch]
  );

  const fetchNotes = useCallback(() => {
    async function getNotes() {
      try {
        const result = await getAllNoteContextInstance(
          state.account.id,
          contextInstance.id,
          dispatch
        );
        setNotes(result.content);
      } catch (error) {
        setNotes(null);
      }
    }

    getNotes();
  }, [contextInstance, state.account.id, dispatch]);

  useEffect(() => {
    fetchNotes();
  }, [fetchNotes]);

  return (
    <>
      {hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_VIEW_CONTEXT_NOTES) ? (
        <EAAccordion
          title={i18next.t('notes.title')}
          logo="note"
          counter={notes?.length}
          opened={false}
          notificationCounter={0} // TODO change when notifications counter is available
          disabled={
            !hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_CREATE_CONTEXT_NOTES)
          }
        >
          {notes && (
            <NotesList
              notes={notes}
              fetchNotes={fetchNotes}
              createNote={createNote}
              updateNote={updateNote}
              deleteNote={deleteNote}
              type="CONTEXT"
            />
          )}
        </EAAccordion>
      ) : (
        <></>
      )}
    </>
  );
};

export default Notes;
